import { Typography } from "@material-ui/core";
import InfoIcon from '@material-ui/icons/Info';
import { CAT_YELLOW } from "./styles";

type PocEntry = {
  contact: string;
  email: string;
};

type PocBoxProps = {
  classes: any;
  contact?: string;
  email?: string;
  pocs?: PocEntry[];
  issues: string[];
};

export function PocBox({
  classes,
  contact,
  email,
  pocs,
  issues,
}: PocBoxProps) {
  // Keep backward compatibility with existing callers that pass pipe-delimited strings.
  const resolvedPocs: PocEntry[] = pocs && pocs.length > 0
    ? pocs
    : (contact && email
        ? contact.split('|').map((rawContact, index) => ({
            contact: rawContact.trim(),
            email: (email.split('|')[index] ?? '').trim(),
          })).filter(p => p.contact || p.email)
        : []);

  return (
    <div className={classes.pocBox}>
      <Typography className={classes.pocTitle}>
        <InfoIcon style={{ fontSize: 16, color: CAT_YELLOW }} />
        Point of Contact &amp; Support
      </Typography>

      {resolvedPocs.map((poc) => (
        <Typography key={`${poc.contact}-${poc.email}`} className={classes.pocItem}>
          <strong>{poc.contact}</strong>
           {poc.email ? (
             <> — <a href={`mailto:${poc.email}`}>{poc.email}</a></>
           ) : null}
        </Typography>
      ))}

      <Typography className={classes.pocTitle} style={{ marginTop: 10 }}>
        <InfoIcon style={{ fontSize: 16, color: '#FF9800' }} />
        Common Issues
      </Typography>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {issues.map(i => (
          <span key={i} className={classes.issueBadge}>
            ⚠ {i}
          </span>
        ))}
      </div>
    </div>
  );
}